import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionButton: {
		id: 'polaris-ideas.view-header.view-subtitle.show-description-button.description-button',
		defaultMessage: 'About this view',
		description: 'About this view, add or edit description',
	},
});
